import React from 'react'
import { animated } from 'react-spring'

export const AnimatedTransition = ({children, style}) => {
    return <animated.div style={style}>{children}</animated.div>
}